import { cloneDeep } from "lodash";
import { castToBoolean } from "../../../lib/util";

class EditProfileController {
  constructor($scope, StaffUserService, APIService, $location, $anchorScroll, Upload, $timeout, $filter) {
    "ngInject";
    this.$scope                 = $scope;
    this.StaffUserService       = StaffUserService;
    this.APIService             = APIService;
    this.Upload                 = Upload;
    this.$timeout               = $timeout;
    this._errors                = [];
    this._loading               = false;
    this._passwordValidityCheck = [];
    this.$location              = $location;
    this.$anchorScroll          = $anchorScroll;
    this.$filter = $filter;
    this.profile = {};
    this.currentlyTransferringFile = null;

    /**
     * Date Pickers
     */
    this._datePickersOpened = {};
    this._datePickersOptions = {};

    let datePickerNames = [ 'claim_date' ];
    let defaultDatePickerOptions = {
        minDate: null,
        maxDate: null,
    };
    for (const datePickerName of datePickerNames){
      this._datePickersOpened[datePickerName] = false;
      this._datePickersOptions[datePickerName] = {...defaultDatePickerOptions};
    }
  }

  $onInit() {
    // Make a working copy of the profile
    this.profile = cloneDeep(this._staffUser.profile);
    this.updateHeadshotImages();
    this.$anchorScroll('header');
    this.updateCertificationExpirationDates();
  }

  updateCertificationExpirationDates() {
    angular.forEach(this.profile.all_certifications, (certification, key) => {
      let cert_id = certification.id;
      angular.forEach(this.profile.assigned_certification_expirations, (expiration, key) => {
        if (cert_id == parseInt(key) && expiration) {
          const date = new Date(expiration);
          certification.expiration_date = this.$filter('date')(date,'MM/dd/yyyy');
        }
      });
    });
  }
  castToBoolean(value, defaultValue){
    return castToBoolean(value, defaultValue);
  }
   updateHeadshotImages() {
     this.StaffUserService.getFile(this.profile.headshot_documents_id).
     then(response => {
       this.profile.headshot_documents_href = response.data.url;
     });
     this.StaffUserService.getFile(this.profile.headshot2_documents_id).
     then(response => {
       this.profile.headshot2_documents_href = response.data.url;
     });
   }

  /**
   * Public properties
   */
  get errors() {
    return this._errors;
  }

  get loading() {
    return this._loading;
  }

  // Imported by component binding
  set staffUser(staffUser) {
    this._staffUser = staffUser;
  }

  get staffUser() {
    return this._staffUser;
  }

  set passwordValidityCheck(val) {
    this._passwordValidityCheck = val;
  }

  get passwordValidityCheck() {
    return this._passwordValidityCheck;
  }

  /**
   * Public methods
   */
  cancel() {
    this.$scope.$emit('hideEditProfile', this.profile);
  }

  save() {
    if (this.$scope.form.$valid) {
      // I'm not sure if this is necessary, but I'm keeping this call just in case there's a side effect I'm unaware of
    }

    this.StaffUserService.setProfile(this.profile)
      .then(() => {
        this._staffUser.profile = cloneDeep(this.profile);
        this.$scope.$emit('hideEditProfile', this.profile);
      });
  }

  validatePassword() {
    this.StaffUserService.validatePassword(this.password1)
      .then(response => {
        if (response.success === false) {
          this.$scope.form.password1.$setValidity('ValidPassword', false);
          this.passwordValidityCheck = response;
        }
        else {
          this.$scope.form.password1.$setValidity('ValidPassword', true);
          this.passwordValidityCheck = null;
        }
      });
  }


  updateTraitSelection(trait_id,checked) {
    if (checked) {
      if (this.profile.assigned_trait_ids.indexOf(trait_id) == -1) {
        this.profile.assigned_trait_ids.push(trait_id);
      }
    } else {
      if (this.profile.assigned_trait_ids.indexOf(trait_id) != -1) {
        this.profile.assigned_trait_ids.splice(this.profile.assigned_trait_ids.indexOf(trait_id), 1);
      }
    }
  }
  isTraitAssigned(trait_id) {
    return this.profile.assigned_trait_ids.indexOf(trait_id) != -1;
  }

  updateCertificationExpiration(cert_id,date) {
    this.profile.assigned_certification_expirations[cert_id] = date;
  }

  updateCertificationSelection(cert_id,checked) {
    if (checked) {
      if (this.profile.assigned_certification_ids.indexOf(cert_id) == -1) {
        this.profile.assigned_certification_ids.push(cert_id);
      }
    } else {
      if (this.profile.assigned_certification_ids.indexOf(cert_id) != -1) {
        this.profile.assigned_certification_ids.splice(this.profile.assigned_certification_ids.indexOf(cert_id),1);
      }
    }
  }

  setCertificationDate(certification) {
    if (certification.expiration_date) {
      certification.expiration_date = new Date(certification.expiration_date);
    }
  }

  isCertificationAssigned(cert_id) {
    return this.profile.assigned_certification_ids.indexOf(cert_id) != -1;
  }

  uploadFile(file, errFile, fileFieldName) {
    if (errFile.length) {
      console.error("ERROR: " + errFile);
    }

    if (file) {
      this.currentlyTransferringFile = file;
      file.upload = this.Upload.upload({
        url: this.APIService.convertPathToURL('/profile_image_upload'),
        data: {id: this.profile.id, fileFieldName: fileFieldName, file:file}
      })
        .then((response) => {
          this.$timeout(() => {
            this.transferResult = response.data;
          });
        }, (response) => {
          if (response.status > 0) {
            this.errorMsg = response.status + ': ' + response.data;
          }
        }, (evt) => {
          this.fileTransferProgress =
            Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });
      file.upload.finally(() => {
        this.StaffUserService.getProfile({ force: true })
          .then(response => {
            this.profile.headshot_documents_id = response.headshot_documents_id;
            this.profile.headshot2_documents_id = response.headshot2_documents_id;
            this.updateHeadshotImages();
          });
        this.currentlyTransferringFile = null;
      });
    }
  }

  /**
   * Private methods
   */
  _clearErrors() {
    this._errors.length = 0;
  }

  _addError(error) {
    this.errors.push(error);
  }

  /****************************
   * Date picker modals
   ****************************/
  get datePickersOpened() {
    return this._datePickersOpened;
  }

  get datePickersOptions() {
    return this._datePickersOptions;
  }

  openDatePicker(certification) {
    certification.is_open = true;
  }
}

export default EditProfileController;
